





























import { DeliveryPointData } from '@/types/delivery-point';
import { normalizeNumber } from '@/utils/normalize';

export default {
  name: 'DeliveryPointsTable',
  props: {
    deliveryPoints: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDeliveryAddress(point: DeliveryPointData): string {
      return `${point.companyName}\n${point.street}\n${point.zipCode} ${point.city}`;
    },
    getProductQuantity(point: DeliveryPointData): number {
      return point.products.reduce(
        (total, product) => total + normalizeNumber(product.numberOfProducts),
        0,
      );
    },
    getProductValue(point: DeliveryPointData): number {
      return point.products.reduce((total, product) => total + normalizeNumber(product.value), 0);
    },
    getAuthorizedPersons(point: DeliveryPointData): string[] {
      const persons = [
        `${point.personOneName} ${point.personOneSurname} (${point.personOnePhone})`,
      ];

      if (point.personSecondName && point.personSecondSurname && point.personSecondPhone) {
        persons.push(
          `${point.personSecondName} ${point.personSecondSurname} (${point.personSecondPhone})`,
        );
      }

      return persons;
    },
  },
};
